export const PRICES_HAS_ERRED = 'PRICES_HAS_ERRED';
export const PRICES_IS_LOADING = 'PRICES_IS_LOADING';
export const PRICES_FETCHED_OK = 'PRICES_FETCHED_OK';



// WEBPACK FOOTER //
// ./src/data/constants/prices.js